var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"holder"},[_c('h2',[_vm._v("Page not found.")]),_vm._v(" "),_c('p',[_vm._v("We're sorry.  We were unable to find this page.  Please go back and try again or "),_c('a',{attrs:{"href":"https://www.arlingtonva.us/contact-arlington/"}},[_vm._v("contact us.")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ce26269","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NotFound.vue
// module id = yPNS
// module chunks = 1